export default __webpack_public_path__ + "static/media/Metropolis-Medium.fc900357.woff";